import { useState } from "react";
import { useSelector } from "react-redux";
import { Grid, Card, Alert, Link } from "@mui/material/";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { style } from "style";
import { checkResponse } from "helpers/notification";
import DatePicker from "react-multi-date-picker";
import React from "react"
import Button from '@mui/material/Button';
import moment from 'moment';
import { alertWarningText } from "helpers/notification";
import { QueryAPI } from "API/QueryAPI";
import { useNavigate } from "react-router-dom"
import MDInput from "components/MDInput";
import { endDateControl } from "helpers/helper";
import gregorian_tr from "helpers/gregorian_tr";
import weekends from "react-multi-date-picker/plugins/highlight_weekends";

function DailyReport() {

    let date = new Date();
    const [startDate, setStartDate] = useState(date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + " 00:00:00");
    const [endDate, setEndDate] = useState(date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + " 23:59:00");

    const maxDate = new Date();
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 3);

    const validateDateRange = (startDate, endDate) => {
        const minDateISO = moment(minDate).format('YYYY-MM-DD HH:mm');
        return !(startDate < minDateISO) && !(endDate < minDateISO);
    }

    const [queryId, setQueryId] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState("");

    const navigate = useNavigate();

    const [queryName, setQueryName] = useState("");

    var userName = useSelector(state => state.common.userName);

    const insertQuery = async e => {

        setShowAlert(false);

        if (!validateDateRange(startDate, endDate)) {
            alertWarningText("Lütfen son üç ay içinde geçerli bir tarih aralığı seçiniz.");
            return;
        }

        if (startDate > endDate) {
            alertWarningText("Lütfen geçerli bir tarih aralığı seçiniz.Bitiş tarihi başlangıç tarihinden küçük olamaz");
            return;
        }

        let parameters = {
            startDate: moment(startDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            endDate: moment(endDateControl(endDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        }

        const isExistQueryResponse = await QueryAPI.IsExistQuery("dailyreport", userName, parameters);
        if (isExistQueryResponse.data.resultObject.isExist) {
            alertWarningText("Talep ettiğiniz sorgu " + isExistQueryResponse.data.resultObject.queryId + " id si ile zaten var. Lütfen sorgular menüsündeki listeden kontrol ediniz.");
            return;
        }

        const insertQueryResponse = await QueryAPI.InsertQuery(
            userName,
            0,
            "dailyreport",
            queryName,
            new Date(),
            parameters
        );
        if (
            checkResponse(
                insertQueryResponse,
                null,
                "Günlük Rapor getirme işlemi başarısız oldu.Lütfen Tekrar deneyin."
            )
        ) {
            if (insertQueryResponse.data.resultObject !== "") {
                setQueryId(insertQueryResponse.data.resultObject);
                setShowAlert(true);
                setAlertType("success");
            }
        }
    }


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={3} pb={1}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={1}
                                px={2}
                                variant='gradient'
                                bgColor='info'
                                borderRadius='lg'
                                coloredShadow='info'
                            >
                                <MDTypography variant='h6' color='white'>
                                    Günlük Rapor
                                </MDTypography>
                                <MDTypography style={{ fontSize: "13px" }} color='white'>
                                    Tüm Gönderim Platformlarından Tarih kriteri ile Gün bazında Özet rapor çekebilirsiniz
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={2} pb={2} px={2}>
                                <Grid container spacing={4}>
                                    <Grid item xs={12} md={12} lg={6}>
                                        <Grid container spacing={0} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>Tarih : </h6>
                                            </Grid>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <DatePicker
                                                    plugins={[weekends()]}
                                                    format="YYYY-MM-DD"
                                                    value={startDate}
                                                    minDate={minDate}
                                                    maxDate={maxDate}
                                                    locale={gregorian_tr}
                                                    style={{
                                                        ...style.datepickerStyle,
                                                        border: '2px solid #ccc',
                                                        borderRadius: '6px',
                                                    }}
                                                    onChange={value => setStartDate(value.format("YYYY-MM-DD HH:mm"))}
                                                />


                                            </Grid>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <DatePicker
                                                    plugins={[weekends()]}
                                                    format="YYYY-MM-DD"
                                                    value={endDate}
                                                    minDate={minDate}
                                                    maxDate={maxDate}
                                                    locale={gregorian_tr}
                                                    style={{
                                                        ...style.datepickerStyle,
                                                        border: '2px solid #ccc',
                                                        borderRadius: '6px',
                                                    }}
                                                    onChange={value => setEndDate(`${value.format("YYYY-MM-DD")} 23:59:00`)}
                                                />


                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={0} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>Sorgu Adı : </h6>
                                            </Grid>
                                            <Grid item xs={8} md={8} lg={8}>
                                                <MDInput
                                                    style={{
                                                        ...style.inputStyle,
                                                        border: '1px solid #ccc',
                                                        borderRadius: '6px',
                                                    }}
                                                    type='text'
                                                    value={queryName}
                                                    onChange={e => setQueryName(e.target.value)}
                                                    inputProps={{ maxLength: 100 }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={0} sx={style.gridStyle}>
                                        <Grid item xs={12} md={12} lg={12}>
                                            <Button style={style.buttonStyle} onClick={insertQuery} >
                                                Sorgu Talebi Oluştur
                                            </Button>
                                        </Grid>
                                    </Grid>

                                    {showAlert ? <Grid container spacing={0} sx={style.gridStyle}>
                                        <Grid item xs={12} md={12} lg={12}>

                                            <Alert
                                                severity="success"
                                                sx={{
                                                    marginLeft: "30px",
                                                    backgroundColor: "#d8f4da",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                    gap: "4px"
                                                }}
                                            >
                                                Sorgunuz <b>{queryId}</b> id si ile işleme alınmıştır.
                                                <b>Sorgular</b> ekranından görüntüleyebilirsiniz.
                                                <Button
                                                    size="small"
                                                    sx={{
                                                        marginLeft: "10px",
                                                        marginRight: "6px",
                                                        textTransform: "none",
                                                        fontWeight: 600,
                                                        fontSize: "12px",
                                                        color: "#000",
                                                        backgroundColor: "#bfe8c6",
                                                        border: "1px solid #6fbf7f",
                                                        borderRadius: "8px",
                                                        padding: "2px 10px",
                                                        minHeight: "26px",

                                                        "&:hover": {
                                                            backgroundColor: "#aee0b7"
                                                        }
                                                    }}
                                                    onClick={() => navigate("/Sorgular", { state: { queryId } })}
                                                >
                                                    Sorguyu Aç
                                                </Button>
                                            </Alert>
                                        </Grid>
                                    </Grid> : ""}

                                </Grid>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );

}
export default DailyReport;